import type { CliE2eeRuntime } from '../../../../lib/e2ee/index.js';
import {
  decryptCliE2eeMessageField,
  e2eeKeyIdFromStoredString,
  storedStringHasE2eeEnvelope,
} from '../../../../lib/e2ee/decrypt-stored-e2ee-content.js';
import type { ParentPromptTurnJson } from './types.js';

function assertE2eeRuntimeForEnvelope(raw: string, e2ee: CliE2eeRuntime | undefined): void {
  if (storedStringHasE2eeEnvelope(raw) && !e2ee) {
    throw new Error(`E2EE_REQUIRED:${e2eeKeyIdFromStoredString(raw) ?? 'unknown'}`);
  }
}

export function decryptParentPromptTurns(
  turns: ParentPromptTurnJson[],
  e2ee: CliE2eeRuntime | undefined,
): ParentPromptTurnJson[] {
  return turns.map((turn) => {
    const promptRaw = typeof turn.promptText === 'string' ? turn.promptText : null;
    const titleRaw = typeof turn.title === 'string' ? turn.title : null;
    if (promptRaw) assertE2eeRuntimeForEnvelope(promptRaw, e2ee);
    if (titleRaw) assertE2eeRuntimeForEnvelope(titleRaw, e2ee);
    return {
      ...turn,
      promptText: decryptCliE2eeMessageField(promptRaw, 'prompt', e2ee),
      title: decryptCliE2eeMessageField(titleRaw, 'title', e2ee),
    };
  });
}
